import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Col, Row, useLayout } from '../../../elements/layout'
import { H2 as ActorName, Html } from '../../../elements/typography'
import { containerWidths } from '../../../style/breakPoints'
import { media, useMediaIs } from '../../../style/media'
import ActorFilmography from '../ActorKnownFor/ActorFilmography'
import ActorPoster from '../ActorPoster/ActorPoster'
import ActorAwards from './ActorAwards/ActorAwards'

const PaddedContainer = styled(View)`
  align-items: center;
  padding: ${(props) => props.theme.spacing.md}px;
  padding-top: ${(props) => props.theme.spacing.sm}px;

  ${media.lg`
    margin-top: ${(props) => props.theme.spacing.lg * 3}px;
  `};
`

const LimitedWidth = styled(View)`
  max-width: ${containerWidths.md}px;
`

const RightSpace = styled(View)`
  margin-right: ${(props) => props.theme.spacing.md}px;
`

const DescriptionHtml = styled(Html)`
  margin-bottom: ${(props) => props.theme.spacing.md}px;
`

const ActorFeaturedDetails = ({ actor }) => {
  const { name, longBio, filmography, awards } = actor
  const { onLayout, width } = useLayout()
  const atLeastBigPhone = useMediaIs('xs')
  const atLeastIPadPro = useMediaIs('md')
  return (
    <PaddedContainer>
      <LimitedWidth>
        <Row>
          <Col size={atLeastBigPhone ? 2 : 3}>
            <RightSpace onLayout={onLayout}>
              <ActorPoster item={actor} width={width} />
            </RightSpace>
          </Col>

          <Col size={5}>
            <ActorName>{name}</ActorName>

            <DescriptionHtml content={longBio} />

            <Row>
              {atLeastIPadPro && filmography && filmography.length > 0 && (
                <Col size={3}>
                  <ActorFilmography filmography={filmography} />
                </Col>
              )}

              {awards && awards.length > 0 && (
                <Col size={7}>
                  <ActorAwards awards={awards} />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </LimitedWidth>
    </PaddedContainer>
  )
}

ActorFeaturedDetails.propTypes = {
  actor: PropTypes.object.isRequired,
}

export default ActorFeaturedDetails
